import { Student } from '../../../shared-components/student/student.model';

export class EFormInstancesFilterParam {
    availableTo: string;
    selectedSites: boolean;
    selectedClasses: boolean;
    selectedStudents: boolean;
    deadlineFrom: Date;
    deadlineTo: Date;
    showFromFrom: Date;
    showFromTo: Date;
    showToFrom: Date;
    showToTo: Date;
    category: string;
    template: string;
    createdFrom: Date;
    createdTo: Date;
    createdBy: string;
    lastUpdatedFrom: Date;
    lastUpdatedTo: Date;
    lastUpdatedBy: string;
    schoolIds: number[];
    classIds: number[];
    students: Student[];
}
